/**
 * OCPX 转化类型常量
 * 统一所有 OCPX 相关的转化类型定义
 */

// 转化类型枚举
export const CONVERSION_TYPE_ENUM = {
  DP: { value: 1, label: '唤起', code: 'DP' },
  DP_FIRST: { value: 2, label: '首唤', code: 'DP_FIRST' },
  LOGIN: { value: 3, label: '登录', code: 'LOGIN' },
  REGISTER: { value: 4, label: '注册', code: 'REGISTER' },
  PAYMENT: { value: 5, label: '付费', code: 'PAYMENT' },
  NEXT_STAY: { value: 6, label: '次留', code: 'NEXT_STAY' },
  VISITS: { value: 7, label: '访问', code: 'VISITS' },
  AUTHENTICATION: { value: 8, label: '认证', code: 'AUTHENTICATION' },
  ORDER: { value: 9, label: '下单', code: 'ORDER' },
  FINISH_THE_ORDER: { value: 10, label: '完单', code: 'FINISH_THE_ORDER' },
  ACTIVATE: { value: 11, label: '激活', code: 'ACTIVATE' },
  EVOKE_C_VALID: { value: 12, label: '有效唤端', code: 'EVOKE_C_VALID' },
  CUSTOMER_ACQUISITION: { value: 13, label: '获客', code: 'CUSTOMER_ACQUISITION' },
  LAHUO: { value: 14, label: '拉活', code: 'LAHUO' },
  LAHUI: { value: 15, label: '拉回', code: 'LAHUI' },
  HUIFANG: { value: 16, label: '回访', code: 'HUIFANG' },
  IMPRESSION: { value: 17, label: '曝光', code: 'IMPRESSION' },
  CLICK: { value: 18, label: '点击', code: 'CLICK' }
}

// 转化类型列表（用于下拉框等）
export const CONVERSION_TYPE_LIST = Object.values(CONVERSION_TYPE_ENUM).map(item => ({
  label: item.label,
  value: item.value,
  code: item.code
}))

// 转化类型映射表（用于快速查找）
export const CONVERSION_TYPE_MAP = {}
Object.values(CONVERSION_TYPE_ENUM).forEach(item => {
  CONVERSION_TYPE_MAP[item.value] = item
})

// 获取转化类型标签
export function getConversionTypeLabel (value) {
  return CONVERSION_TYPE_MAP[value]?.label || '未知'
}

// 获取转化类型代码
export function getConversionTypeCode (value) {
  return CONVERSION_TYPE_MAP[value]?.code || 'UNKNOWN'
}

// 获取转化类型对象
export function getConversionType (value) {
  return CONVERSION_TYPE_MAP[value] || null
}
